var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handle}},[(_vm.pause)?_c('div',[_vm._v(" "+_vm._s(_vm.$t("handle.resume"))+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.$t("handle.pause"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }